<template>
  <div class="content">
    <h3 ref="pageHeader" class="pageHeader">在线安全考试课程管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.title" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.post" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.fbzt" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">课程创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column fixed prop="title" label="标题" min-width="200">
        </custom-table-column>
        <custom-table-column prop="safe_level" label="安全分类" width="100">
        </custom-table-column>
        <custom-table-column prop="post_desc" label="发布状态" width="100">
        </custom-table-column>
        <custom-table-column prop="user_count" label="学习人数" width="100">
        </custom-table-column>
        <custom-table-column label="课程起止日期" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.start_date && scope.row.end_date">{{ scope.row.start_date }} 至 {{ scope.row.end_date
            }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="question_name" label="绑定试卷" min-width="160">
        </custom-table-column>
        <custom-table-column prop="exam_count" label="可考次数" width="100">
        </custom-table-column>
        <custom-table-column label="考试有效期" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.exam_start_date && scope.row.exam_end_date">{{ scope.row.exam_start_date }} 至 {{
              scope.row.exam_end_date }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="exam_time" label="考试时间" width="100">
        </custom-table-column>
        <custom-table-column label="课程起止日期" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.start_date && scope.row.end_date">{{ scope.row.start_date }} 至 {{ scope.row.end_date
            }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="depart" label="院系" min-width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160">
        </custom-table-column>
        <custom-table-column prop="desc" label="课程描述" min-width="220">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="160">
        </custom-table-column>
        <!-- <custom-table-column label="封面" min-width="120">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic && scope.row.pic.indexOf('http') > -1" :src="scope.row.pic"
              :preview-src-list="scope.row.pic.split(',')" style=" height: 100px;margin-right: 4px;">
            </el-image>
            <span v-else>{{ scope.row.pic }}</span>
          </template>
</custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="220">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="detailMethod(scope.row)" type="text" size="small">详情</el-button>
            <el-button v-if="scope.row.is_edit == 1" @click="handleEdit(scope.row)" type="text"
              size="small">编辑</el-button>
            <el-button v-if="scope.row.is_edit == 1 && scope.row.post == 1"
              @click="handleSetStatus(scope.row.id, 0, `取消发布课程${scope.row.title}`)" type="text"
              size="small">取消发布</el-button>
            <el-button v-else-if="scope.row.is_edit == 1"
              @click="handleSetStatus(scope.row.id, 1, `发布课程${scope.row.title}`)" type="text"
              size="small">发布</el-button>
            <el-button v-if="scope.row.is_edit == 1" @click="handleVideos(scope.row)" type="text"
              size="small">学习资料管理</el-button>
            <!-- <el-button v-if="scope.row.post == 1 && !scope.row.question_id" @click="handleQuestions(scope.row)" type="text"
              size="small">绑定试卷</el-button> -->
            <el-button v-if="scope.row.is_edit == 1" @click="handleQuestions(scope.row)" type="text" size="small">{{
              scope.row.question_id ? '重新绑定' :
                '绑定试卷' }}</el-button>
            <!-- <el-button v-if="scope.row.post == 1 && scope.row.question_id" @click="handleQuestions(scope.row)" type="text"
              size="small">预览试卷</el-button> -->
            <!-- <el-button v-if="scope.row.post == 1" @click="handleStatistics(scope.row)" type="text"
              size="small">学习统计</el-button> -->
            <el-button v-if="scope.row.is_edit == 1" @click="handleDelet(scope.row.id)" type="text"
              size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="760px">
      <course-form ref="courseForm" :value="ruleForm" :type="type" :exam-config-row="examConfigRow"
        @submit="handleFormSubmit"></course-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ delText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="学习资料管理" :visible.sync="detailDialogVisible" width="946px">
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleAddItem">上传学习资料</el-button>
            <el-button type="primary" @click="handleSyncResources">同步课程资料</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="排序" prop="sort" width="60">
          </custom-table-column>
          <custom-table-column fixed prop="chapter_name" label="资料名称" min-width="150">
          </custom-table-column>
          <custom-table-column prop="post_desc" label="发布状态" width="100">
          </custom-table-column>
          <custom-table-column prop="total_time" label="时长(秒)/页数" width="120">
          </custom-table-column>
          <custom-table-column label="资料" min-width="220">
            <template slot-scope="scope" v-if="scope.row.video_url">
              <el-link type="primary" v-for="(item, index) in scope.row.video_url.split(',')"
                @click="handleVideoClick(item)" :key="index">{{ decodeURIComponent($until.getFileName(item))
                }}</el-link>
            </template>
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click="handleEditItem(scope.row, ['device', 'training_room'])" type="text"
                size="small">编辑</el-button>
              <el-button v-if="scope.row.post == 1"
                @click="handleSetStatusItem(scope.row.id, 0, `取消发布学习资料${scope.row.chapter_name}`)" type="text"
                size="small">取消发布</el-button>
              <el-button v-else @click="handleSetStatusItem(scope.row.id, 1, `发布学习资料${scope.row.chapter_name}`)"
                type="text" size="small">发布</el-button>
              <el-button @click="handleDeletItem(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>
      <!-- 同步课程资料 -->
      <el-dialog :close-on-click-modal="false" title="同步课程资料" :visible.sync="syncVisible" width="600px" append-to-body>
        <el-form label-width="100px" class="demo-ruleForm">
          <el-form-item label="课程资料">
            <el-select v-model="syncIds" multiple filterable clearable placeholder="请选择要同步的课程资料" style="width:400px;">
              <el-option v-for="item in syncOptions" :key="item.id" :label="item.title" :value="item.id">
                <p>{{ item.title }}</p>
                <p v-if="item.filename" class="el-option-tips">文件名：{{ decodeURIComponent(item.filename) }}</p>
                <p v-if="item.total_time" class="el-option-tips">时长（秒）/页数：{{ item.total_time }}</p>
                <p v-if="item.source" class="el-option-tips">来源：{{ item.source }} </p>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="syncVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitSync">同 步</el-button>
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="视频预览" :visible.sync="innerVideoDialogVisible" width="900px"
        append-to-body>
        <div style="text-align:center;">
          <video ref="previewVideo" :src="videoSrc" style="width:100%;max-height:68vh;display:block;margin:0 auto;"
            controls controlslist="nodownload noremoteplayback" disablepictureinpicture
            @contextmenu.prevent="onVideoContextMenu" @ratechange="lockPlaybackRate"></video>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" title="资料预览" :visible.sync="pdfPreviewVisible" width="900px"
        append-to-body>
        <div v-loading="!pdfSrc || !pdfTotalPages" style="min-height:120px;">
          <div :style="{
            width: pdfScaleW ? pdfScaleW + 'px' : '100%',
            margin: '0 auto',
            overflow: 'hidden',
            boxSizing: 'border-box'
          }">
            <pdf v-if="pdfSrc && pdfTotalPages" :key="pdfPreviewKey" :src="pdfSrc" :page="pdfCurPage"
              @page-size="onPdfPageSize" style="display:block;width:100%;border:1px solid #ebeef5;"></pdf>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:center;">
            <el-button :disabled="pdfCurPage <= 1" @click="pdfCurPage--">上一页</el-button>
            <span style="margin:0 16px;">{{ pdfCurPage }} / {{ pdfTotalPages }}</span>
            <el-button :disabled="pdfCurPage >= pdfTotalPages" @click="pdfCurPage++">下一页</el-button>
          </div>
        </span>
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :title="itemTitle" :before-close="closeDialog"
        :visible.sync="innerDialogVisible" width="544px" append-to-body>
        <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
          <el-form-item label="资料名称" prop="chapter_name">
            <el-input v-model="ruleForm1.chapter_name" clearable placeholder="请输入" style="width:360px;"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="ruleForm1.sort" placeholder="请输入" style="width:360px;"></el-input-number>
          </el-form-item>
          <el-form-item label="上传资料" prop="video_url">
            <div style="width:342px;">
              <VideoUpload ref="videoUpload" @setFormValForKey="setFormValForKey"
                @setFormTimeForKey="setFormTimeForKey">
              </VideoUpload>
            </div>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:462px;text-align:right;">
            <el-button type="primary" v-if="typee == 'add'"
              @click="submitFormByFun('ruleForm1', createItemMethod)">确认保存</el-button>
            <el-button type="primary" v-if="typee == 'edit'"
              @click="submitFormByFun('ruleForm1', updateItemMethod)">确认编辑</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="学习统计" :visible.sync="detailDialogVisible2" width="946px">
      <div>
        <custom-table :data="tableData2" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column fixed prop="chapter_name" label="资料名称" min-width="150">
          </custom-table-column>
          <custom-table-column prop="post_desc" label="发布状态" width="100">
          </custom-table-column>
          <custom-table-column prop="total_time" label="资源时长(秒)/页数" width="100">
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total2' ref="pageChild2" @getList="getList2"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible2 = false">取 消</el-button>
        <!-- <el-button type="primary" @click="deleteTarinRoom">确 定</el-button> -->
      </span>

    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="绑定配置" :visible.sync="linkDialogVisible" width="600px">
      <el-form :model="linkForm" :rules="linkRules" ref="linkFormRef" label-width="110px">
        <el-form-item label="选择试卷" prop="question_id">
          <el-select v-model="linkForm.question_id" filterable remote reserve-keyword clearable placeholder="输入试卷名称搜索"
            :remote-method="remotePaperOptions" :loading="paperLoading" style="width:430px">
            <el-option v-for="item in paperOptions" :key="item.id" :label="item.name" :value="item.id">
              <div style="line-height:1.5;">
                <div>{{ item.name }}</div>
                <div v-if="item.structure_1" class="el-option-tips">组织结构：{{ item.structure_1 }} {{ item.structure_2 }}
                </div>
                <div v-if="item.type" class="el-option-tips">组卷类型：{{ item.type }}</div>
                <div v-if="item.pass_line" class="el-option-tips">及格线：{{ item.pass_line }} </div>
                <div v-if="item.created_at" class="el-option-tips">创建时间：{{ item.created_at }}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试有效期" prop="dateRange">
          <el-date-picker v-model="linkForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:430px">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="次数用尽后" prop="end_doing">
          <el-select v-model="linkForm.end_doing" clearable placeholder="请选择" style="width:430px;">
            <el-option v-for="item in $store.state.endDoingOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可考次数" prop="exam_count">
          <el-input-number v-model="linkForm.exam_count" :min="1" :max="999"></el-input-number>
          <span class="tipText">正整数,允许考试次数</span>
        </el-form-item>
        <el-form-item label="考试时间" prop="examMinutes">
          <el-input-number v-model="linkForm.examMinutes" :min="1" :max="999"></el-input-number>
          <span class="tipText">分钟,提交为 "N分钟"</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="linkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="linkPaperMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageLine from '@/components/page.vue';
import CourseForm from './components/courseForm.vue';
import pdf from 'vue-pdf';
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinVideoUpload } from '@/assets/js/mixin/videoupload';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinUpload, mixinVideoUpload],
  data() {
    return {
      formInline: {
        title: '',
        post: '',
        structure_1: '',
        structure_2: '',
      },
      formInline1: {
        course_id: ''
      },
      formInline2: {
        course_id: ''
      },
      videoSrc: '',
      pdfPreviewVisible: false,
      pdfSrc: '',
      pdfTotalPages: 0,
      pdfCurPage: 1,
      pdfRatio: 0.7071, // 页面宽高比(竖版 A4 默认,page-size 事件到后更新)
      pdfScaleW: 0, // 按视口高度计算出的完整页宽(无滚动条)
      detailDialogVisible: false,
      detailDialogVisible2: false,
      // 同步课程资料
      syncVisible: false,
      syncIds: [],
      syncOptions: [],
      currentCourseSafeLevel: '',
      linkDialogVisible: false,
      linkForm: {
        course_id: '',
        scope: '',
        question_id: '',
        dateRange: [],
        end_doing: '',
        exam_count: 1,
        examMinutes: 60
      },
      paperOptions: [],
      paperLoading: false,
      examConfigRow: {},
      linkRules: {
        question_id: [{ required: true, message: '请选择试卷', trigger: 'change' }],
        // dateRange: [{ required: true, message: '请选择考试有效期', trigger: 'change' }],
        exam_count: [{ required: true, message: '请输入可考次数', trigger: 'blur' }],
        end_doing: [{ required: true, message: '请选择', trigger: 'change' }],
        examMinutes: [{ required: true, message: '请输入考试时间', trigger: 'blur' }]
      },
      innerDialogVisible: false,
      innerVideoDialogVisible: false,
      pdfPreviewKey: 0, // pdf 组件重建 key(切换资料时强制新建实例,避免 vue-pdf 复用加载失败)
      uploadType: 'image',
      btnTitle: '点击上传封面图片',
      ruleForm: {
        "id": '',
        "title": "",
        "desc": "",
        "start_date": "",
        "end_date": "",
        "safe_level": "",
        "expire_month": 0,
        "pre_exam": '',
        "user_type": '',
        "training_room_id": '',
        "structure_1": "",
        "structure_2": "",
        "resources_ids": [],
        "teacher_ids": [],
        "student_ids": [],
      },
      ruleForm1: { "course_id": "", "chapter_name": "", "video_url": "", "key": "", "size": "", "total_time": "", sort: 0 },
      rules1: {
        chapter_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入' }],
        video_url: [{ required: true, message: '请上传' }],
      },
      params: {
        type: 'safe',
      },
      levell: [1, 2],
      centerDialogVisible: false,
      total: 0,
      tableData: [],
      fileFieldName: 'pic',
      tableData1: [],
      total1: 0,
      tableData2: [],
      total2: 0,
      typee: 'add',
      itemTitle: '新增',
      vfileFormName: 'ruleForm1',//表名
      vfileFieldName: 'video_url',
    };
  },
  components: {
    PageLine,
    CourseForm,
    pdf,
  },
  created() {
    this.$store.dispatch('getTarinMent');
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {

    handleAdd() {
      this.type = 'add'
      this.title = "新增"
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.courseForm) {
          this.$refs.courseForm.openAdd()
        }
      });
    },
    closeDialog(done) {
      if (this.ruleForm1.video_url && !this.ruleForm1.id) {
        this.$confirm("视频已上传，是否退出", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: "warning",
        })
          .then(() => {
            done();
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除',
            // });
          });
      } else {
        done();
      }
    },
    // 资料预览分流:pdf 走 pdf 预览,其余按视频播放
    handleVideoClick(src) {
      const lower = String(src || '').toLowerCase()
      if (/\.pdf(\?|#|$)/.test(lower)) {
        this.openPdfPreview(src)
      } else {
        this.innerVideoDialogVisible = true;
        this.videoSrc = src;
      }
    },
    // 视频:禁止右键(拦截“视频另存为/下载”等浏览器菜单)
    onVideoContextMenu(e) {
      e.preventDefault()
    },
    // 视频:锁定 1 倍速(拦截任何倍速修改入口,ratechange 时强制复位)
    lockPlaybackRate() {
      const el = this.$refs.previewVideo
      if (el && el.playbackRate !== 1) el.playbackRate = 1
    },
    async openPdfPreview(url) {
      this.pdfCurPage = 1
      this.pdfTotalPages = 0
      this.pdfSrc = '' // 先卸载旧 pdf 组件
      this.pdfScaleW = 0
      this.pdfPreviewVisible = true
      try {
        // 每次都手动请求文件,转成本地 Blob URL 再交给 vue-pdf,避免其内部对直链的缓存/复用导致切换不加载
        const resp = await fetch(url)
        if (!resp.ok) throw new Error('HTTP ' + resp.status)
        const blob = await resp.blob()
        if (this._pdfObjUrl) URL.revokeObjectURL(this._pdfObjUrl)
        const objectUrl = URL.createObjectURL(blob)
        this._pdfObjUrl = objectUrl
        const task = pdf.createLoadingTask(objectUrl)
        const pdfDoc = await task.promise
        this.pdfTotalPages = pdfDoc.numPages || 1
        this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
        this.pdfCurPage = 1
        this.pdfPreviewKey++ // 全新 key 挂载新实例,只加载一次
        this.pdfSrc = objectUrl
      } catch (e) {
        this.$message.error('PDF 加载失败，请确认文件格式')
        this.pdfPreviewVisible = false
      }
    },
    // pdf 渲染后回调:更新页面宽高比并重算显示宽度(整页适配,不出现滚动条)
    onPdfPageSize(width, height) {
      if (width && height) {
        this.pdfRatio = width / height
        this.pdfScaleW = this.calcPdfWidth(this.pdfRatio)
      }
    },
    // 按可用高度计算整页宽:页面完整呈现,高度不超过弹窗可用区域(底部为翻页条)
    calcPdfWidth(ratio) {
      const winH = (window.innerHeight || 800)
      const winW = (window.innerWidth || 1280)
      // 可用高度:视口 - 弹窗头部/底部按钮条/外边距
      const availH = Math.max(320, winH - 240)
      // 最大宽度:弹窗 900 内容约 860,再受视口宽限制
      const maxW = Math.min(860, winW - 80)
      const w = Math.min(maxW, availH * (ratio || 0.7071))
      return Math.max(280, Math.round(w))
    },
    handleAddItem() {
      this.clearState1(false)
      this.innerDialogVisible = true;
      this.typee = 'add';
      this.itemTitle = '新增';
      this.ruleForm1.course_id = this.formInline1.course_id;
    },
    handleVideos(row) {
      this.tableData1 = []
      this.detailDialogVisible = true;
      this.formInline1.course_id = row.id
      // 同步课程资料时按该课程的安全分类筛选
      this.currentCourseSafeLevel = row.safe_level
      this.handleQuery1()
    },
    // 打开同步弹窗:拉课程资料列表(按安全类型筛选)
    async handleSyncResources() {
      this.syncIds = [];
      this.syncOptions = [];
      this.syncVisible = true;
      // 安全分类取当前课程的安全分类(课程没设分类时不传该参数)
      let params = this.$until.deleteNullPrototype({
        safe_level: this.currentCourseSafeLevel,
        page: 1,
        size: 999,
        status: 1, // 只拉已发布的课程资料
      });
      let res = await this.$api.instance.interfaceServer('api/new_course_resources/list', 'get', params);
      if (res.code == 0 && res.data) {
        // 保留接口返回的全部字段:下拉选项里还要展示时长/来源/文件名等
        this.syncOptions = res.data.data || [];
      }
    },
    // 同步课程资料:api/new_course_resources/sync
    async submitSync() {
      if (!this.syncIds.length) {
        this.$message({
          type: 'warning',
          center: true,
          message: '请选择要同步的课程资料！',
        });
        return;
      }
      let params = {
        ids: this.syncIds.join(','),
        course_id: this.formInline1.course_id,
      };
      let res = await this.$api.instance.interfaceServer('api/new_course_resources/sync', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '同步成功！',
        });
        this.syncVisible = false;
        this.handleQuery1();
      }
    },
    handleQuestions(row) {
      this.linkForm.course_id = row.id
      this.linkForm.scope = row.scope
      this.linkForm.question_id = ''
      this.linkForm.end_doing = ''
      this.linkForm.dateRange = []
      this.linkForm.exam_count = 1
      this.linkForm.examMinutes = 60
      this.linkDialogVisible = true
      this.loadPaperOptions('')
    },
    // 加载可选试卷(status=1 已发布),远程搜索按名称
    async loadPaperOptions(keyword) {
      this.paperLoading = true;
      let params = { status: 1 };
      if (keyword) params.name = keyword;
      if (this.linkForm.scope) params.scope = this.linkForm.scope;
      params.page = 1;
      params.size = 50;
      let res = await this.$api.instance.interfaceServer('api/new/paper/lists', 'get', params);
      if (res.code == 0 && res.data) {
        this.paperOptions = res.data.data || [];
      }
      this.paperLoading = false;
    },
    remotePaperOptions(keyword) {
      this.loadPaperOptions(keyword);
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async getList1() {
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer('api/new_course_chapter/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    handleStatistics(row) {
      this.detailDialogVisible2 = true;
      this.formInline2.course_id = row.id
      this.handleQuery2()
    },
    handleQuery2() {
      this.$nextTick(() => {
        this.$refs.pageChild2.page = 1;
        this.getList2();
      });
    },
    async getList2() {
      let params = this.$until.deleteNullPrototype(this.formInline2);
      params.page = this.$refs.pageChild2.page;
      params.size = this.$refs.pageChild2.size;
      let res = await this.$api.instance.interfaceServer(`api/new_course/statistics/${params.course_id}`, 'get');
      if (res.code == 0 && res.data) {
        this.tableData2 = res.data.data;
        this.total2 = res.data.total;
      }
    },
    // 查看详情:复用编辑回填,只读展示(表单 disabled);考试配置直接从列表行读取
    detailMethod(row) {
      this.type = 'view'
      this.title = '详情'
      this.examConfigRow = row || {}
      this.centerDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.courseForm) {
          this.$refs.courseForm.openView(row)
        }
      })
    },
    // 编辑回显:转公共课程表单组件(组件内按列表数据回填,含 desc 兜底/组织人员加载)
    handleEdit(row) {
      this.type = 'edit'
      this.title = '编辑'
      this.centerDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.courseForm) {
          this.$refs.courseForm.openEdit(row)
        }
      })
    },
    // 课程表单组件校验通过后提交(add/edit 通用)
    async handleFormSubmit(params) {
      let res, msg;
      if (this.type == 'add') {
        res = await this.$api.instance.interfaceServer('api/new_course/insert', 'post', params);
        msg = '提交成功！';
      } else {
        res = await this.$api.instance.interfaceServer('api/new_course/save', 'post', params);
        msg = '编辑成功！';
      }
      if (res.code == 0) {
        this.$message({ type: 'success', center: true, message: msg });
        // 表单已迁公共组件,$refs.ruleForm 不存在,不能用 mixin 的 clearState(内部 resetForm 会抛错),自行关闭并刷新
        this.centerDialogVisible = false;
        if (this.type == 'add') {
          this.handleQuery();
        } else {
          this.getList();
        }
      }
    },
    handleEditItem(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      this.typee = 'edit'
      this.itemTitle = "编辑"
      this.ruleForm1 = this.$until.delProp(row, filterArr)
      this.innerDialogVisible = true;
      this.$nextTick(() => {
        if (row.video_url) {
          this.$refs.videoUpload.currentFile = {
            name: row.key,
            size: row.size
          };
          this.$refs.videoUpload.isNeedUp = false;
          this.$refs.videoUpload.progress = {
            percent: 100,
            visible: true,
            text: '上传成功',
            status: "success"
          };
        }
      });
    },
    handleSetStatus(id, post, title) {
      this.confirmBox('warning', `是否${title}`, { id, post }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/new_course/toggle-publish/${params.id}?post=${params.post}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.getList();
      }
    },
    async linkPaperMethod() {
      this.$refs.linkFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = {
          id: this.linkForm.course_id,
          question_id: this.linkForm.question_id,
          exam_start_date: this.linkForm.dateRange[0],
          exam_end_date: this.linkForm.dateRange[1],
          exam_count: this.linkForm.exam_count,
          exam_time: this.linkForm.examMinutes + '分钟',
          end_doing: this.linkForm.end_doing
        };
        let res = await this.$api.instance.interfaceServer('api/new_course/link/paper', 'post', params);
        if (res.code == 0) {
          this.$message({
            type: 'success',
            center: true,
            message: '绑定成功！',
          });
          this.linkDialogVisible = false;
          this.getList();
        }
      });
    },
    handleSetStatusItem(id, post, title) {
      this.confirmBox('warning', `是否${title}`, { id, post }, this.setStatusItem);
    },
    async setStatusItem(params) {
      let res = await this.$api.instance.interfaceServer(`api/new_course_chapter/toggle-publish/${params.id}?post=${params.post}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.handleQuery1();
      }
    },

    handleDeletItem(id) {
      this.confirmBox('warning', `此操作将删除该学习资料，是否继续`, { id }, this.deleteItemMethod);
    },
    handleQuery() {
      this.beforeQueryByKeyNew({ dep: 'structure_1', major: 'structure_2', formK: 'formInline' });
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    getOrganList() {
      this.beforeGetOrgan({ limit: false, dep: "structure_1", major: "structure_2" });
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/new_course/delete/${this.delid}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async deleteItemMethod(params) {
      let res = await this.$api.instance.interfaceServer(`api/new_course_chapter/delete/${params.id}`, 'post');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.handleQuery1();
      }
    },
    async createItemMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm1);
      let res = await this.$api.instance.interfaceServer(`api/new_course_chapter/create`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '保存成功！',
        });
        this.clearState1();
      }
    },
    async updateItemMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm1);
      let res = await this.$api.instance.interfaceServer(`api/new_course_chapter/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState1();
      }
    },

    clearState1(isRefesh = true) {
      this.ruleForm1 = { "course_id": "", "chapter_name": "", "video_url": "", "key": "", "size": "", "total_time": "", sort: 0 }
      this.$nextTick(() => {
        if (this.$refs.videoUpload) {
          this.resetForm('ruleForm1')
          this.$refs.videoUpload.currentFile = null;
          this.$refs.videoUpload.isNeedUp = true;
          this.$refs.videoUpload.progress = {
            percent: 0,
            visible: false,
            text: '等待用户点击上传...',
            status: null
          };
        }
      });
      if (isRefesh) {
        this.innerDialogVisible = false;
        this.handleQuery1();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_course/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.tipText {
  margin-left: 10px;
  color: #999;
  font-size: 12px;
}
</style>
